import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ColorPalette from '../../../../colorpalette/ColorPalette';
import CustomButton from '../../../../components/buttons/CustomButton';

const SendingSummary = ({
  selectedRecipients,
  recipients,
  messageTemplate,
  messageVariables,
  sendingMethod,
  whatsappConfigured,
  sending,
  handleSendToAll,
  processMessageForRecipient,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: ColorPalette.white,
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '24px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.03)',
        border: `1px solid ${ColorPalette.border}`
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600, color: ColorPalette.blueDark, marginBottom: '16px' }}>
        Resumo do Envio
      </Typography>
      
      <Box sx={{
        backgroundColor: ColorPalette.white,
        padding: '16px',
        borderRadius: '8px',
        marginBottom: '24px',
        border: `1px solid ${ColorPalette.blueMain}`
      }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: ColorPalette.blueDark, marginBottom: '8px' }}>
          Destinatários
        </Typography>
        <Typography variant="h4" sx={{ color: ColorPalette.secondary, fontWeight: 600, marginBottom: '8px' }}>
          {selectedRecipients.length}
        </Typography>
        <Typography variant="body2" sx={{ color: ColorPalette.textMedium, marginBottom: '16px' }}>
          de {recipients.length} contatos disponíveis
        </Typography>
        
        <Divider sx={{ margin: '8px 0 16px 0' }} />
        
        <Box sx={{
          backgroundColor: ColorPalette.white,
          padding: '12px',
          borderRadius: '8px',
          border: `1px solid ${ColorPalette.border}`,
          maxHeight: '150px',
          overflow: 'auto',
          whiteSpace: 'pre-wrap'
        }}>
          <Typography variant="body2" sx={{ color: ColorPalette.textDark }}>
            {recipients.length > 0 && messageTemplate ?
              processMessageForRecipient(messageTemplate, messageVariables, recipients[0]) :
              'Nenhuma mensagem definida'}
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ marginTop: '24px' }}>
        <CustomButton
          style="secondary"
          variant="contained"
          label="Enviar para Todos Selecionados"
          icon={<SendIcon />}
          onClick={handleSendToAll}
          disabled={
            sending ||
            selectedRecipients.length == 0 ||
            messageTemplate.trim() == '' ||
            (sendingMethod == 'whatsapp_api' && !whatsappConfigured)
          }
          fullWidth
        />
      </Box>
    </Paper>
  );
};

export default SendingSummary;